const getters = {
  selectedType: state => state.selected_type,
  selectedId: state => state.selected_id,
  dataCartReservation: state => state.data_cart_reservation,
  dataCartTakeAway: state => state.data_cart_take_away,
  dataCartDelivery: state => state.data_cart_delivery,
  dataCartDineIn: state => state.data_cart_dinein,
  selectedStore: state => state.selected_store,
  selectedOutlet: state => state.selected_outlet,
  authData: state => state.auth_data,
  checkUser: state => state.auth_data,
  notSystem: (state) => {
    let notSystem = false
    if (state.auth_data) {
      if (state.auth_data.auth_by !== 'SYSTEM') {
        notSystem = true
      }
    }
    return notSystem
  },
  orderData: state => state.order_data,
  dataVerification: state => state.data_verification,
  dataTypeVerification: state => state.type_verification,
  getLoadingState: (state) => {
    return state.loading
  },
  getLoadingAxiosState: (state) => {
    return state.loading_axios
  },
  errorType: state => state.error_type,
  errorMessage: state => state.error_message,
  tokensExpiry: state => state.auth_data.expires_time,
  showError: (state) => {
    return state.show_error
  },
  urlDomain: state => state.url_domain
}
export default getters
